class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener('input', () => {
        this.toggleResetButton();
      });
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    const closeButton =
      this.querySelector('.search-modal__close-button') ||
      this.closest('.search-modal')?.querySelector('.search-modal__close-button');

    if (this.input.value.trim().length > 0) {
      if (resetIsHidden) this.resetButton.classList.remove('hidden');
      if (closeButton) closeButton.classList.add('hidden');
    } else {
      if (!resetIsHidden) this.resetButton.classList.add('hidden');
      if (closeButton) closeButton.classList.remove('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
